import { Divider, Header, Icon } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import CostBalance from "astrid-web/src/features/costs/components/CostBalance/CostBalance";

import Flex from "../../../../components/Flex/Flex";
import Button from "../../../ui/components/Buttons/Button";
import DropdownMenu from "../../../ui/components/DropdownMenu/DropdownMenu";
import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";
import SecondaryMenu from "../../../ui/components/SecondaryMenu/SecondaryMenu";

import FinalizedCostsTable from "../../../costs/components/FinalizedCostsTable/FinalizedCostsTable";
import OpenCostsTable from "../../../costs/components/OpenCostsTable/OpenCostsTable";
import OpenCostsActions from "../../../costs/components/OpenCostsTable/components/OpenCostsActions";

import ProductionAgreements from "../../components/ProductionAgreements/ProductionAgreements";

import useProductionFinance from "./hooks/useProductionFinance";

export default function ProductionFinanceView({ producer, production, partyId }) {
	const { t } = useTranslation();

	const [
		{
			costs,
			currency,
			setCurrency,
			currencyOptions,
			openCosts,
			menuOptions,
			finalizableOpenCosts,
			totalOpenAmount,
			totalExpenseAmount,
			totalRevenueAmount,
			totalFinalizedAmount,
			totalEstimatedOpenAmount,
		},
		loading,
		error,
	] = useProductionFinance({
		partyId,
		production,
	});

	return (
		<LoadingContext loading={loading} error={error}>
			<Flex>
				<SecondaryMenu options={menuOptions} style={{ marginBottom: 0 }} />

				{currencyOptions.length > 1 && (
					<DropdownMenu
						options={currencyOptions}
						trigger={
							<Button basic circular size="small">
								{currency}
								<Icon name="chevron down" fitted style={{ paddingLeft: 7, fontSize: "0.8rem" }} />
							</Button>
						}
						onChange={(e, { value }) => setCurrency(value)}
					/>
				)}
			</Flex>

			<Divider />

			{partyId === production.producer && (
				<CostBalance
					totalExpenseAmount={totalExpenseAmount}
					totalRevenueAmount={totalRevenueAmount}
					currency={currency}
				/>
			)}

			<Header as="h4" content={t("openCosts", "Open")} />

			<OpenCostsTable
				costs={openCosts}
				partyId={partyId}
				currency={currency}
				production={production}
				totalOpenAmount={totalOpenAmount}
				totalEstimatedOpenAmount={totalEstimatedOpenAmount}
				footer={<OpenCostsActions partyId={partyId} production={production} openCosts={finalizableOpenCosts} />}
			/>

			<Header as="h4" content={t("finalizedCosts", "Finalized")} />
			<FinalizedCostsTable
				costs={costs}
				partyId={partyId}
				currency={currency}
				totalFinalizedAmount={totalFinalizedAmount}
			/>

			<Header as="h4" content={t("productionAgreement", "Production Agreement")} />
			<ProductionAgreements production={production} />
		</LoadingContext>
	);
}
